import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-server-error-page',
  templateUrl: './server-error-page.component.html',
  styleUrls: ['./server-error-page.component.scss']
})
export class ServerErrorPageComponent {
  constructor(private location: Location) { }

  back() {
    this.location.back();
  }
}
